import Helper from './Helper';

class NotesCorrection {
  constructor(config = {}) {
    const {
      ncTitle
    } = config;
    
    this.ncTitles = Array.prototype.slice.call(document.querySelectorAll(ncTitle));

    if(this.ncTitles && this.ncTitles.length){
      this.bindEvents();
    }
  }

  bindEvents() {
    this.ncTitles.forEach(title => {
      const paragraph = title.nextElementSibling;
      const titleHeight = title.querySelector('.title-text').offsetHeight;
      const paragraphHeight = paragraph.offsetHeight;
      const height = titleHeight < paragraphHeight ? paragraphHeight : titleHeight;
      if(paragraph.nextElementSibling.classList.contains('full-width') && window.innerWidth >= 768){
        paragraph.style.height = height + "px";
      }
    });
  }

}

export default NotesCorrection;
